import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connectionIsGyroDevice, getConnectionIcon, getConnectionSubscriptionPlansAndPrices } from '../../../Lib/ConnectionsUtils'
import I18n from '../../../i18n/i18n'
import FullScreenLoader from '../../../Components/UI/Loaders/FullScreenLoader'
import ContentCard from '../../../Components/UI/ContentCards/ContentCard'
import ConnectionUpgradeCard from '../../../Components/UI/Connections/ConnectionUpgradeCard'
import ConnectionsStatus from '../../../Components/UI/Connections/ConnectionsStatus'
import AppText from '../../../Components/UI/Texts/AppText'
import styles from '../../../Components/Styles/Screens/Forms'

export default class Upgrades extends Component {

  static propTypes = {
    connections: PropTypes.array.isRequired,
    fetching: PropTypes.bool,
    onPressItem: PropTypes.func.isRequired
  }

  static defaultProps = {
    connections: null,
    fetching: false,
    onPressItem: null
  }

  renderConnectionUpgradeItem = (connection, index) => {
    const { name, deviceId = null, device = {} } = connection
    const { campaign = {}, online, offlineGyro } = device
    const { name: campaignName } = campaign
    const subscriptionsPlansAndPrices = getConnectionSubscriptionPlansAndPrices(connection, deviceId === null)
    const unpaidSince = campaign?.subscription?.unpaidSince

    const isGyroDevice = connectionIsGyroDevice(connection)
    const icon = getConnectionIcon(device)

    return (
      <ConnectionUpgradeCard
        key={'connection-upgrade-' + index}
        connection={connection}
        title={name || campaignName}
        subscriptionsPlansAndPrices={subscriptionsPlansAndPrices}
        onPressItem={(item) => { this.props.onPressItem(connection._id, item) }}
        isLast={(index + 1) === this.props.connections.length}
        unpaidSince={unpaidSince}
        icon={icon}
        deviceOnline={isGyroDevice
          ? (offlineGyro ? true : online )
          : online || !deviceId}
      />
    )
  }

  renderContent = () => {
    if (this.props.fetching) { return null }
    if (this.props.connections.length === 0) {
      return <ConnectionsStatus text={I18n.t('screens.upgrades.textEmpty')} icon={'list'} />
    }
    return (
      <ContentCard
        title={I18n.t('screens.upgrades.titleCard')}
        renderContent={
          () => (
            <div>
              <AppText text={I18n.t('screens.upgrades.text')} />
              <div style={styles.emptySpace} />
              <div style={styles.emptySpaceSmall} />
              { this.props.connections.map((c, i) => this.renderConnectionUpgradeItem(c, i)) }
            </div>
          )
        }
      />
    )
  }

  render = () => {
    return (
      <div>
        <div style={styles.mainBody}>
          { this.renderContent() }
        </div>
        <FullScreenLoader visible={this.props.fetching}/>
      </div>
    )
  }

}